const SET_ARCHIVE_DASHBOARD = (state, payload) => {
  state.archiveResult.totalCount = payload.searchItems.totalCount;
  state.archiveResult.results = payload.searchItems.results;

  state.user = payload.user;
  state.usageEventsDisabled = payload.usageEventsDisabled;
};

export default SET_ARCHIVE_DASHBOARD;
